import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RequestBuilder } from '@/core/api/request-builder';
import { StrictHttpResponse } from '@/core/api/strict-http-response';
import { SICOM_PATHS } from 'src/sicom-paths';

export interface UploadPcmsoAnexoParams {
    uf: string;
    idMedico: number;
    nuRegistro: number | string;
}

export function uploadPcmsoAnexo(http: HttpClient, rootUrl: string, params: UploadPcmsoAnexoParams, file: File, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(rootUrl, uploadPcmsoAnexo.PATH, 'post');
    rb.path('uf', params.uf, {});
    rb.path('idMedico', params.idMedico, {});
    rb.path('nuRegistro', params.nuRegistro, {});
    // multipart body
    rb.body({ file }, 'multipart/form-data');

    return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r.clone({ body: undefined }) as unknown as StrictHttpResponse<void>;
        })
    );
}

uploadPcmsoAnexo.PATH = SICOM_PATHS.registro.medico.pcmso.anexo;
